import React from 'react'
import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { PowerDialerAccessLayout } from 'pages/powerDialer/layout/powerDialerAccessLayout'
import { PowerDialerListPage } from 'pages/powerDialer/pages/list'
import { PowerDialerLayout } from 'pages/powerDialer/layout/PowerDialerLayout'
import { PowerDialerViewPage } from 'pages/powerDialer/pages/view'
import { PowerDialerRoutes } from 'pages/powerDialer/route/type'

export const PowerDialerRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route element={<PowerDialerAccessLayout />}>
        <Route element={<PowerDialerLayout />}>
          <Route index element={<PowerDialerListPage />} />
          <Route path={`${PowerDialerRoutes.view}/:id`} element={<PowerDialerViewPage />} />
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
})
